import { render, staticRenderFns } from "./BotoesSignatario.vue?vue&type=template&id=0bb40509"
import script from "./BotoesSignatario.vue?vue&type=script&lang=js"
export * from "./BotoesSignatario.vue?vue&type=script&lang=js"
import style0 from "./BotoesSignatario.vue?vue&type=style&index=0&id=0bb40509&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports